import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { GridComponent, RowSelectEventArgs, RowDeselectEventArgs, SelectionSettingsModel, ToolbarItems, PageSettingsModel } from '@syncfusion/ej2-angular-grids';

import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { MovimientoService, MenuFuncionService, MonedaService, AlicuotaIvaService, TipoMovimientoService, TenantService, EstadoService } from '../../../../src/app/shared/services';

import { MenuFuncionCodes, Moneda, Movimiento, SearchAlicuotaIvaRequest, SearchMonedaRequest, AlicuotaIva, TipoMovimiento, DialogConfirmRequest, EstadoConstants, SearchMovimientoRecurrenteRequest,
  SearchTipoMovimientoRequest, LocalStorageKeys, TenantFeatureFlags, DialogConfirmResponse, GenerarMovimientoDeudaDto, SearchEstadoRequest, Estado
 } from '../../../../src/app/shared/model';

import { DialogConfirmComponent } from '../../../../src/app/shared/components/modals/dialogConfirm.component';

@Component({
  selector: 'app-movimientoRecurrente',
  templateUrl: './movimientoRecurrente.component.html',
  styles: []
})

export class MovimientoRecurrenteComponent implements OnInit {

  @ViewChild('deudasGrid')
  public deudasGrid: GridComponent;

  isValidating: boolean = false;
  isSearching: boolean = false;
  isSaving: boolean = false;
  isMonedaSearching: boolean = false;
  isAlicuotaIvaSearching: boolean = false;
  isTipoMovimientoSearching: boolean = false;
  isEstadoSearching: boolean = false;

  isFileAttaching: boolean = false;
  isMovimientoDeudaSearching: boolean = false;
  isAttachmentSearching: boolean = false;

  newFileDescripcion: string = "";

  isRosbaco: boolean = false;
  solicitarConfirmacion: boolean = true;

  canEdit: boolean = false;
  canView: boolean = false;
  canAddDeuda: boolean = false;
  canChangeState: boolean = false;

  msgError: string = "";
  item: Movimiento;

  alicuotaIvaList: AlicuotaIva[];
  monedaList: Moneda[];
  estadoList: Estado[];
  tipoMovimientoList: TipoMovimiento[];
  deudasPendientesList: any[];

  searchForm: FormGroup;

  tenantFeatureFlags: TenantFeatureFlags;

  totalPorPagar: number = 0;
  public totalesSeleccionados: any[] = [];

  montoTotal: number = 0;

  public deudaSelectionOptions?: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;

  constructor(
    private formBuilder: FormBuilder,
    private location: Location,
    public dialog: MatDialog,
    private sharedFunctions: SharedFunctions,
    private route: ActivatedRoute,
    private router: Router,
    private menuService: MenuFuncionService,
    private monedaService: MonedaService,
    private alicuotaIvaService: AlicuotaIvaService,
    private tipoMovimientoService: TipoMovimientoService,
    private tenantService: TenantService,
    private movimientoService: MovimientoService,
    private estadoService: EstadoService
  ) {
    this.deudaSelectionOptions = { persistSelection: true, type: 'Multiple', checkboxOnly: true };
  }

  ngOnInit(): void {
    this.isValidating = true;
    this.movimientoService.clearTempFolder().subscribe(data => {
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    })

    this.menuService.checkMenuPadre(MenuFuncionCodes.MOVIMIENTO).subscribe(data => {
      if (data != null && data.Success && data?.Result) {
        this.tenantService.getTenantFeatureFlagsById(this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId)).subscribe(dataTenant => {
          this.isValidating = false;
          if (dataTenant != null && dataTenant.Success) {
            this.tenantFeatureFlags = dataTenant.Result;

            this.isRosbaco = this.sharedFunctions.isRosbacoUser();

            this.canEdit = data.Result.some(x => x == MenuFuncionCodes.MOVIMIENTO_EDIT);
            this.canView = data.Result.some(x => x == MenuFuncionCodes.MOVIMIENTO_LIST);

            this.canAddDeuda = data.Result.some(x => x == MenuFuncionCodes.MOVIMIENTO_DEUDA);
            this.canChangeState = data.Result.some(x => x == MenuFuncionCodes.MOVIMIENTO_CHANGE_STATE);

            this.loadView();
          }
        },
        (err: HttpErrorResponse) => {
          this.isValidating = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.onCancel();
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.buildForm();

    this.searchMovimientosRecurrentes();

    this.getTiposMovimientos();
    this.getMonedas();
    this.getEstados();
    this.getAlicuotaIva();
  }

  buildForm() {
    var fechaHoy = new Date();

    var cId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId);
    if (cId != null && cId.length > 0 && cId > 0)
      cId = Number(cId);

    this.searchForm = this.formBuilder.group({
      'FechaMovimientoDesde': [new Date(fechaHoy.getFullYear(), fechaHoy.getMonth() - 1, 1)],
      'FechaMovimientoHasta': [fechaHoy],
      'FechaVencimientoDesde': [null],
      'FechaVencimientoHasta': [null],

      // 'NroDocumento': [null],
      // 'MailContacto': [null],
      // 'MovilContacto': [null],
      // 'Usuario': [null],
      // 'ComunidadId': [null],
      'ConsorcioId': [cId],
      // 'UnidadFuncionalId': [null],
      // 'Proveedor': [null],

      // 'PedidoId': [null],
      // 'Contrato': [null],

      // 'Detalle': [null],
      'TipoMovimientoId': [null],
      'MonedaId': [null],
      'Estados': [null],
      // 'MedioPagoId': [null],
      'Signo': [-1],

      'VerSoloRecurrentes': [true],
      'VerSoloDeudasPendientes': [null],
      // 'VerSoloActivos': [true],
      'gridPage': [1]
    });

    // var filtros = this.sharedFunctions.getReporteFiltros("app-movimientoLista");
    // if (filtros != null)
    //   this.searchForm.patchValue(filtros);
  }

  clearDate(formFieldName: string) {
    if (formFieldName != null && formFieldName.length > 0) {
      if (this.searchForm.get(formFieldName) != null && this.searchForm.get(formFieldName)?.value)
        this.searchForm.get(formFieldName)?.setValue(null);
    }
  }

  checkVerSoloRecurrentes() {
    return (this.searchForm?.get("VerSoloRecurrentes")?.value ?? false);
  }

  isProcessing() {
    return (this.isSearching || this.isSaving);
  }

  getEstados() {
    if (!this.canChangeState)
      return false;

    var r = new SearchEstadoRequest(null, null, true, "Nombre", null, null, true);
    this.isEstadoSearching = true;

    this.estadoService.searchMovimientoEstados(r).subscribe(data => {
      this.isEstadoSearching = false;
      this.estadoList = data?.result?.filter(f => f.Id != EstadoConstants.ESTADO_MOVIMIENTO_CANCELADO);
    },
    (err: HttpErrorResponse) => {
      this.isEstadoSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  compareEstados(o1: number, o2: number): boolean {
    return o1 == o2;
  }

  getMonedas() {
    var r = new SearchMonedaRequest(null, null, true, "Codigo", null, null, null, true);
    this.isMonedaSearching = true;

    this.monedaService.search(r).subscribe(data => {
      this.isMonedaSearching = false;
      this.monedaList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isMonedaSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getTiposMovimientos() {
    var r = new SearchTipoMovimientoRequest(null, null, true, "Nombre", null, null, -1, null, true);
    this.isTipoMovimientoSearching = true;

    this.tipoMovimientoService.search(r).subscribe(data => {
      this.isTipoMovimientoSearching = false;
      this.tipoMovimientoList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isTipoMovimientoSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getAlicuotaIva() {
    this.isAlicuotaIvaSearching = true;
    var r = new SearchAlicuotaIvaRequest(null, null, true, "Nombre", null, null, null, null, true);

    this.alicuotaIvaService.search(r).subscribe((data)=>{
      this.isAlicuotaIvaSearching = false;
      this.alicuotaIvaList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isAlicuotaIvaSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  onAlicuotaIvaSelect() {
    this.calcularMontos();
  }

  calcularMontos() {
    // var importeBase = (this.formGroup.get("MontoBase")?.value ?? 0);
    // var importePercepciones = (this.formGroup.get("MontoPercepciones")?.value ?? 0) * (this.operacion > 0 ? -1 : 1);

    // var alicuota = this.alicuotaIvaList?.find(f => f.Id == this.formGroup.get("AlicuotaIvaId")?.value);
    // if (alicuota != null && alicuota.Id > 0)
    //   this.montoIva = (importeBase * (alicuota.Porcentaje / 100));
    // else
    //   this.montoIva = 0;

    // this.montoTotal = importeBase + this.montoIva + (importePercepciones * (this.formGroup.get("CantidadCuotas")?.value ?? 1));
    // this.montoCuota = (this.montoTotal * (1 + ((this.formGroup.get('PorcentajeAjusteCuota').value ?? 0) / 100))) / (this.formGroup.get("CantidadCuotas")?.value ?? 1);

    this.calcularTotalPorPagar();
  }

  /*
  getErrorFechaMovimiento() {
    return this.formGroup.get('FechaMovimiento')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorTipoMovimientoId() {
    return this.formGroup.get('TipoMovimientoId')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorEstadoId() {
    return this.formGroup.get('EstadoId')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorDetalle() {
    var v = this.formGroup.get('Detalle');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorMonedaId() {
    return this.formGroup.get('Moneda')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorMontoBase() {
    return this.formGroup.get('MontoBase')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorMontoPercepciones() {
    return this.formGroup.get('MontoPercepciones')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErroNroComprobante() {
    var v = this.formGroup.get('NroComprobante');
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorMedioPagoId() {
    return this.formGroup.get('MedioPagoId')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorAlicuotaIvaId() {
    return this.formGroup.get('AlicuotaIvaId')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorObservacion() {
    var v = this.formGroup.get('Observacion');
    if (v?.hasError('maxlength'))
      return 'Límite de 300 caracteres alcanzado';
    return '';
  }

  getErrorCantidadCuotas() {
    var v = this.formGroup.get('CantidadCuotas');
    if (v?.hasError('min'))
      return 'Debe ingresar un valor mayor a 0';
    return '';
  }

  getErrorFechaInicioCuota() {
    var v = this.formGroup.get('FechaInicioCuota');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    return '';
  }

  getErrorDiasRecurrenteCuotas() {
    var v = this.formGroup.get('DiasRecurrenteCuotas');
    if (v?.hasError('maxlength'))
      return 'Límite de 300 caracteres alcanzado';
    return '';
  }

  getErrorPorcentajeAjusteCuota() {
    var v = this.formGroup.get('PorcentajeAjusteCuota');
    if (v?.hasError('min'))
      return 'El porcentaje debe ir entre 0 y 100';
    if (v?.hasError('max'))
      return 'El porcentaje debe ir entre 0 y 100';
    return '';
  }
  */

  searchMovimientosRecurrentes() {
    var r = new SearchMovimientoRecurrenteRequest(null, null, true, "FechaMovimiento", null, null, null, null, null, null, null, -1, this.checkVerSoloRecurrentes(), false, true);

    if (!this.checkVerSoloRecurrentes()) {
      r = { ...r, ...this.searchForm.value }
    }

    this.isMovimientoDeudaSearching = true;
    this.movimientoService.getMovimientosRecurrentes(r).subscribe(data => {
      this.isMovimientoDeudaSearching = false;
      this.deudasPendientesList = data?.result;

      // for (var i=0; i<this.deudasPendientesList.length; i++)
      //   this.deudasPendientesList[i].MontoPago = 0;

      this.calcularTotalPorPagar();
    },
    (err: HttpErrorResponse) => {
      this.isMovimientoDeudaSearching = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onDeudaDataBound(args: any) {
    var seleccionados = this.deudasPendientesList?.filter(f => f.Seleccionado == true);

    // Restaurar la selección de filas
    if (seleccionados != null && seleccionados.length > 0) {
      var pageRows = this.deudasGrid.getRowsObject();
      if (pageRows != null && pageRows.length > 0) {
        var indexes : number[] = [];
        for (var i=0; i<pageRows.length; i++) {
          if (seleccionados.some(f => f.Id == (pageRows[i].data as any).Id))
            indexes.push(pageRows[i].index);
        }

        if (indexes != null && indexes.length > 0)
          this.deudasGrid.selectRows(indexes);
      }
    }
  }

  public onDeudaRowSelect(args: RowSelectEventArgs): void {
    if (args.isHeaderCheckboxClicked) {
      var multiSelection = this.deudasGrid.getRowsObject();
      if (multiSelection != null && multiSelection.length > 0) {
        for (var i=0; i<multiSelection.length; i++)
          this.deudasPendientesList.find(f => f.Id == (multiSelection[i].data as any).Id).Seleccionado = true;
      }
    }
    else {
      if (args?.data != null && (args?.data as any).Id != null)
        this.deudasPendientesList.find(f => f.Id == (args?.data as any).Id).Seleccionado = true;
    }

    this.calcularTotalPorPagar();
  }

  onDeudaRowDeselected(args: RowDeselectEventArgs ): void {
    //Solo cuando hace click en el checkbox de la grilla deselecciona
    if (args.isHeaderCheckboxClicked) {
      var multiSelection = this.deudasGrid.getRowsObject();
      if (multiSelection != null && multiSelection.length > 0) {
        for (var i=0; i<multiSelection.length; i++)
          this.deudasPendientesList.find(f => f.Id == (multiSelection[i].data as any).Id).Seleccionado = false;
      }
    }
    else {
      if (args?.data != null  && (args?.data as any).Id != null && args?.target?.className == "e-frame e-icons e-uncheck")
        this.deudasPendientesList.find(f => f.Id == (args?.data as any).Id).Seleccionado = false;
    }

    this.calcularTotalPorPagar();
  }

  onGuardar() {
    if (this.deudasPendientesList == null || this.deudasPendientesList.length == 0) {
      this.sharedFunctions.showMessage("Debe tener al menos un movimiento en el listado para continuar con la operación", "Error");
      return false;
    }

    if (this.solicitarConfirmacion) {
      const dialogRef = this.dialog.open(DialogConfirmComponent, {
        data: new DialogConfirmRequest(
          "Confirmación de Operación",
          "¿Seguro que desea generar los " + (this.deudasPendientesList?.length ?? 0) + " movimientos que figuran en el listado?",
          "Sí",
          "No"
        )
      });

      dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
        if (result != null && result.Accepted) {
          this.doGuardar();
        }
      });
    }
    else
      this.doGuardar();
  }

  doGuardar() {
    var r: GenerarMovimientoDeudaDto[] = [];

    for (var i=0; i<this.deudasPendientesList.length; i++) {

      var p = new GenerarMovimientoDeudaDto(
        this.deudasPendientesList[i].Id,
        this.deudasPendientesList[i].TipoMovimientoId,
        this.deudasPendientesList[i].CuentaImputadaId,
        this.deudasPendientesList[i].CuentaImputada,
        this.deudasPendientesList[i].CuentaDetalleId,
        this.deudasPendientesList[i].CuentaDetalle,

        this.deudasPendientesList[i].EstadoId,
        this.deudasPendientesList[i].MonedaId,
        this.deudasPendientesList[i].AlicuotaIvaId,
        this.deudasPendientesList[i].FechaMovimiento,
        this.deudasPendientesList[i].FechaVencimiento,
        this.deudasPendientesList[i].MontoBase,
        this.deudasPendientesList[i].MontoPercepciones,

        this.deudasPendientesList[i].CantidadCuotas,
        this.deudasPendientesList[i].FechaInicioCuota,
        this.deudasPendientesList[i].DiasRepeticionCuotas,
        this.deudasPendientesList[i].PorcentajeAjusteCuota,
        this.deudasPendientesList[i].AplicarAjusteIncremental,

        false,
        null,
        null,

        this.deudasPendientesList[i].Detalle,
        this.deudasPendientesList[i].NroComprobante,
        this.deudasPendientesList[i].Observacion,

        false,
        0,

        this.deudasPendientesList[i].Adjuntos
      );

      r.push(p);
      // console.log('doGuardar request: ', r);
    }

    this.isSaving = true;
    this.movimientoService.generarMovimientosRecurrentes(r).subscribe(data => {
      this.isSaving = false;
      if (data != null && data.Success && data.Result != null && data.Result) {
        this.sharedFunctions.showMessage("Se guardaron correctamente los datos!", "Operación Exitosa!");
        this.onCancel();
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isSaving = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onCancel() {
    this.location.back();
  }

  calcularTotalPorPagar() {
    this.totalesSeleccionados = [];

    if (this.deudasPendientesList != null && this.deudasPendientesList.length > 0) {
      for (var i=0; i<this.deudasPendientesList.length; i++) {
        var item = this.deudasPendientesList[i];
        var index = this.totalesSeleccionados.findIndex(v => v.key == item.Moneda);

        if (index == null || index < 0) {
          this.totalesSeleccionados.push({ key: item.Moneda, value: 0 });
          index = this.totalesSeleccionados.length - 1;
        }

        var montoIva = 0
        var alicuota = this.alicuotaIvaList?.find(f => f.Id == item.AlicuotaIvaId);
        if (alicuota != null && alicuota.Id > 0)
          montoIva = (item.MontoBase * (alicuota.Porcentaje / 100));
        else
          montoIva = 0;

        this.totalesSeleccionados[index].value += parseFloat(item.MontoBase) + montoIva;
      }
    }
  }

  onDeudaGridFieldChange(movimientoId: number, event: any) {
    // console.log("onDeudaGridFieldChange - movimientoId: " + movimientoId, event);
    if (movimientoId != null && movimientoId > 0 && this.deudasPendientesList != null) {

      var controlName = event?.target?.name ?? event?.targetElement?.name ?? event?.source?.ngControl?.name;
      var controlValue = event?.value ?? event?.target?.value ?? event?.option?.value;
      // console.log("onDeudaGridFieldChange - controlName: " + controlName + " - controlValue: " + controlValue);

      var index = this.deudasPendientesList?.findIndex(f => f.Id == movimientoId);
      if (index >= 0) {
        switch (controlName) {
          case "FechaMovimiento":
            this.deudasPendientesList[index].FechaMovimiento = controlValue;
            break;
          case "FechaVencimiento":
            this.deudasPendientesList[index].FechaVencimiento = controlValue;
            break;
          case "Detalle":
            this.deudasPendientesList[index].Detalle = controlValue;
            break;
          case "TipoMovimientoId":
            this.deudasPendientesList[index].TipoMovimientoId = controlValue;
            break;
          case "MonedaId":
            this.deudasPendientesList[index].MonedaId = controlValue;
            this.deudasPendientesList[index].Moneda = this.monedaList?.find(f => f.Id == controlValue)?.Codigo;

            this.calcularTotalPorPagar();
            break;
          case "AlicuotaIvaId":
            this.deudasPendientesList[index].AlicuotaIvaId = controlValue;
            this.calcularTotalPorPagar();
            break;
          case "MontoBase":
            this.deudasPendientesList[index].MontoBase = parseFloat(controlValue);
            this.calcularTotalPorPagar();
            break;
          case "EstadoId":
            this.deudasPendientesList[index].EstadoId = controlValue;
            break;
        }

        this.deudasGrid.refresh();
        this.calcularTotalPorPagar();
      }
    }
  }

  onRemove(movimientoId: number) {

    if (this.solicitarConfirmacion) {
      const dialogRef = this.dialog.open(DialogConfirmComponent, {
        data: new DialogConfirmRequest(
          "Confirmación de Operación",
          "¿Seguro que desea quitar el movimiento del actual listado de recurrentes?",
          "Sí",
          "No"
        )
      });

      dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
        if (result != null && result.Accepted) {
          this.doMovimientoDelete(movimientoId);
        }
      });
    }
    else {
      this.doMovimientoDelete(movimientoId);
    }
  }

  doMovimientoDelete(movimientoId: number) {
    if (movimientoId != null && movimientoId > 0 && this.deudasPendientesList != null) {
      var index = this.deudasPendientesList?.findIndex(f => f.Id == movimientoId);
      if (index >= 0) {
        this.deudasPendientesList.splice(index, 1);
        this.deudasGrid.refresh();

        this.calcularTotalPorPagar();
      }
    }
  }

  onFileAttach(movimientoId, event) {

    if (movimientoId == null || movimientoId <= 0 || this.deudasPendientesList == null || this.deudasPendientesList.length == 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un movimiento para continuar", "Error");
      this.deudasGrid.refresh();
      return false;
    }

    const files = event.target.files;

    if (files != null && files.length > 0) {

      var index = this.deudasPendientesList?.findIndex(f => f.Id == movimientoId);
      if (index == null || index < 0) {
        this.sharedFunctions.showMessage("No se encontró el movimiento seleccionado", "Error");
        this.deudasGrid.refresh();
        return false;
      }

      this.isFileAttaching = true;
      this.deudasPendientesList[index].Adjuntos = [];
      this.movimientoService.uploadAttachTemp(files).subscribe(data => {
        this.isFileAttaching = false;
        if (data != null && data.Success && data.Result != null && data.Result.Archivos != null && data.Result.Archivos.length > 0) {
          for (let i=0; i<data.Result.Archivos.length; i++) {
            if (data.Result.Archivos[i] != null) {
              this.deudasPendientesList[index].Adjuntos.push(data.Result.Archivos[i]);
              this.deudasGrid.refresh();
            }
          }
        }
        else
          this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error intentando subir los archivos", "Error");
      },
      (err: HttpErrorResponse) => {
        this.isFileAttaching = false;
        this.sharedFunctions.handleError(err, true);
      })

    }
  }

  openAdjuntos(item: any) {
    if (item != null && item.Adjuntos != null && item.Adjuntos.length > 0) {
      for (var i=0; i<item.Adjuntos.length; i++) {
        if (item.Adjuntos[i].UrlDocumento != null && item.Adjuntos[i].UrlDocumento.length > 0)
          window.open(item.Adjuntos[i].UrlDocumento, "_blank");
      }
    }
    else {
      this.sharedFunctions.showMessage("No hay archivos adjuntos para visualizar", "Error");
      this.deudasGrid.refresh();
    }
  }
}
